export default "assets/images/cnil-rgpd-check-black-5afed2f0.png";